import { SelectedEquipmentInfo } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { DeleteEquipmentDrawerForm } from './delete-equipment-drawer-form';
import { DeleteEquipmentDrawerHeader } from './delete-equipment-drawer-header';
import { DeleteEquipmentDrawerWrapper } from './delete-equipment-drawer-wrapper';

export const DeleteEquipmentDrawer = ({
  selectedEquipmentInfo
}: {
  selectedEquipmentInfo: SelectedEquipmentInfo;
}) => {
  return (
    <DeleteEquipmentDrawerWrapper>
      <DeleteEquipmentDrawerHeader />
      <DeleteEquipmentDrawerForm
        selectedEquipmentInfo={selectedEquipmentInfo}
      />
    </DeleteEquipmentDrawerWrapper>
  );
};
